module.exports = __webpack_public_path__ + "img/img-3.f7fa7482.webp";